import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
	professionBox: {
		borderRadius: '8px',
		padding: '24px',
		backgroundColor: theme.colors.primary.main + '1A !important',
	},
	primaryChip: {
		...theme.typography.body3,
	},
	specialtyItem: {
		borderRadius: '8px',
		padding: '12px',
		backgroundColor: '#FFFFFF',
		height: '48px',
	},
	dialog: {
		'& .MuiPaper-root': {
			width: '600px',
			maxWidth: '100%',
		},
	},
	addProfessionBtn: {
		'&.MuiButton-contained': {
			backgroundColor: theme.colors.background.element.veryLight,
		},
		'& .MuiButton-label': {
			color: theme.colors.secondary.main,
		},
	},
	addProfessionIcon: {
		'& path': {
			fill: theme.colors.secondary.main,
		},
	},
	addIcon: {
		'& path': {
			stroke: theme.colors.secondary.main,
		},
	},
}))
